import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import LogInView from './LogInView';
import DefaultLoginIllustration from './DefaultLoginIllustration';
import SignUpView from './SignUpView';
import Button from 'flarum/common/components/Button';
import extractText from 'flarum/common/utils/extractText';
import Page from 'flarum/common/components/Page';
import classList from 'flarum/common/utils/classList';
const routes = () => ({
  'sycho-private-facade.login': {
    label: extractText(app.translator.trans('sycho-private-facade.forum.log_in_label')),
    component: LogInView,
    next: 'sycho-private-facade.signup'
  },
  'sycho-private-facade.signup': {
    label: extractText(app.translator.trans('sycho-private-facade.forum.sign_up_label')),
    component: SignUpView,
    next: 'sycho-private-facade.login'
  }
});
export default class PrivateFacade extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "currentRoute", void 0);
    _defineProperty(this, "routes", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.routes = routes();
    // @ts-ignore
    this.currentRoute = this.routes[app.current.data.routeName];
    app.setTitle(this.currentRoute.label);
    if (!document.body.classList.contains('body--privateFacade')) {
      document.body.classList.add('body--privateFacade');
    }
    const showHeader = !['show_only_logo', 'hide_secondary_items'].includes(app.forum.attribute('sycho-private-facade.header_layout'));
    this.bodyClass = classList({
      'App--privateFacade': true,
      'App--privateFacade--showHeader': showHeader,
      'App--privateFacade--logoOnly': !showHeader,
      'App--privateFacade--primaryBg': app.forum.attribute('sycho-private-facade.primary_color_bg')
    });
  }
  view() {
    return m("div", {
      className: "PrivateFacade"
    }, m("div", {
      className: "PrivateFacade-container container"
    }, m("div", {
      className: "PrivateFacade-AuthView"
    }, m("div", {
      className: "PrivateFacade-AuthView-interface",
      "data-primary-background": app.forum.attribute('sycho-private-facade.primary_color_bg')
    }, m("h2", {
      className: "PrivateFacade-AuthView-interface-title"
    }, app.forum.attribute('sycho-private-facade.screen_banner_title')), m("p", {
      className: "PrivateFacade-AuthView-interface-message"
    }, m.trust(app.forum.attribute('sycho-private-facade.screen_banner_message'))), m(DefaultLoginIllustration, null)), m("div", {
      className: "PrivateFacade-AuthView-form"
    }, m(this.currentRoute.component, {
      routeSwitcher: () => app.forum.attribute('allowSignUp') ? m('[', null, m("div", {
        className: "PrivateFacade-AuthView-separator"
      }, m("span", {
        class: "PrivateFacade-AuthView-separator-label"
      }, app.translator.trans('sycho-private-facade.forum.or_label'))), m(Button, {
        className: "Button Button--block PrivateFacade-Button--outline PrivateFacade-Button",
        onclick: () => {
          var _app$history$getPrevi, _app$history$getPrevi2;
          if (['sycho-private-facade.login', 'sycho-private-facade.signup'].includes((_app$history$getPrevi = app.history.getPrevious()) == null ? void 0 : _app$history$getPrevi.name) && ((_app$history$getPrevi2 = app.history.getPrevious()) == null ? void 0 : _app$history$getPrevi2.name) === this.currentRoute.next) {
            app.history.back();
          } else {
            app.history.push(this.currentRoute.next, this.routes[this.currentRoute.next].label, app.route(this.currentRoute.next));
            m.route.set(app.route(this.currentRoute.next));
          }
        }
      }, this.routes[this.currentRoute.next].label)) : null
    })))));
  }
}
flarum.reg.add('sycho-private-facade', 'forum/components/PrivateFacade', PrivateFacade);